import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import Dropdown from "../Dropdown";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";

class SectionItemSelectWithAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      comboValue: {}
    };
  }

  handleOnButtonClick = () => {
    const { comboValue } = this.state;
    const { item, column, onPropChange } = this.props;
    const items = item[column.accessor] || [];

    if(column.isReadonly){
      return;
    }

    if (onPropChange && comboValue && (comboValue["key"] !== undefined)) {
      onPropChange({ [column.accessor]: items.concat([comboValue]) });
      this.setState({ comboValue: {} });
    }
  };

  handleOnSelect = val => {
    const { column } = this.props;
    if(column.irReadonly){
      return
    }

    this.setState({ comboValue: val })
  }

  render() {
    const { comboValue } = this.state;
    const { t, item, column } = this.props;
    const itemsKey = (item[column.accessor] || []).map(item => item.key);

    const values =
      typeof column.values === "function"
        ? column.values(item) || []
        : this.props.values || [];

    const filteredValue = values.filter(item => !itemsKey.includes(item.key));

    if (!filteredValue || !filteredValue.length) return <div />;

    return (
      <div
        key={`sectionItemSelectWithAdd-${column.accessor}`}
        className={classNames("sectionItemSelectWithAdd")}
      >
        <ColumnTitleWithIcon column={column} item={item}/>
        <div className={classNames("sectionItemSelectWithAddContainer")}>
          <Dropdown
            values={filteredValue}
            labelField="value"
            valueField="key"
            readonly={column.isReadonly}
            searchBy="value"
            value={comboValue["value"] || ""}
            onSelect={val => this.handleOnSelect(val)}
          />
          <div
            className={classNames("sectionItemSelectButton", "btn", "denied")}
            onClick={this.handleOnButtonClick}
          >
            {t("basic.ADD_BUTTON")}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SectionItemSelectWithAdd);
